// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const melmetal: PokeData = {
  "id": 809,
  "name": "melmetal",
  "height": 25,
  "weight": 8000,
  "base_experience": 270,
  "types": [
    PokeType.STEEL
  ],
  "api_moves": [
    "mega-punch",
    "thunder-punch",
    "headbutt",
    "tail-whip",
    "hyper-beam",
    "thunder-shock",
    "thunder-wave",
    "harden",
    "acid-armor",
    "protect",
    "dynamic-punch",
    "superpower",
    "flash-cannon",
    "discharge",
    "double-iron-bash"
  ],
  "moves": [
    "thunder-punch",
    "headbutt",
    "thunder-shock",
    "protect",
    "superpower",
    "magnet-pull",
    "metal-rush",
    "gear-up",
    "metal-sound",
    "magnet-bomb",
    "scrap-throw",
    "behemoth-bash",
    "metal-claw"
  ],
  "evolution_chain": {
    "id": 429,
    "item": null,
    "species": [
      {
        "name": "melmetal",
        "order": 809,
        "types": [
          PokeType.STEEL
        ],
        "evolves_from_species_id": 808,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 161,
    "speed": 46,
    "ability_power": 193
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
